"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bulkCheckInSchema = exports.rescheduleSchema = exports.excuseSchema = exports.cancelSchema = exports.noShowSchema = exports.checkInSchema = exports.appointmentInstanceSchema = void 0;
const zod_1 = require("zod");
const enums_js_1 = require("../enums.js");
const localDate_js_1 = require("../localDate.js");
exports.appointmentInstanceSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    kind: zod_1.z.enum(enums_js_1.ApptKinds),
    serviceType: zod_1.z.enum(enums_js_1.ServiceTypes),
    clientId: zod_1.z.string().uuid().nullable(),
    clientName: zod_1.z.string().nullable().optional(),
    cohortId: zod_1.z.string().nullable().optional(),
    resourceId: zod_1.z.string().uuid(),
    resourceName: zod_1.z.string().optional(),
    resourceType: zod_1.z.string().optional(),
    appointmentId: zod_1.z.string().uuid().nullable(),
    scheduledDate: localDate_js_1.localDateSchema,
    startMin: localDate_js_1.timeMinSchema,
    endMin: localDate_js_1.timeMinSchema,
    placeOfService: zod_1.z.enum(enums_js_1.PlacesOfService),
    viaTelehealth: zod_1.z.boolean().optional(),
    status: zod_1.z.enum(enums_js_1.AttendanceStatuses),
    checkedInAt: zod_1.z.string().datetime().nullable().optional(),
    checkedOutAt: zod_1.z.string().datetime().nullable().optional(),
    lateMinutes: zod_1.z.number().int().min(0).nullable().optional(),
    noShowReason: zod_1.z.string().nullable().optional(),
    cancellationReason: zod_1.z.string().nullable().optional(),
    rescheduledToId: zod_1.z.string().uuid().nullable().optional(),
    notes: zod_1.z.string().nullable().optional(),
});
exports.checkInSchema = zod_1.z.object({
    lateMinutes: zod_1.z.number().int().min(0).optional(),
    notes: zod_1.z.string().max(1000).optional(),
});
exports.noShowSchema = zod_1.z.object({
    reason: zod_1.z.string().min(1).max(500),
});
exports.cancelSchema = zod_1.z.object({
    by: zod_1.z.enum(['CLIENT', 'PROVIDER', 'CLINIC']),
    reason: zod_1.z.string().min(1).max(500),
});
exports.excuseSchema = zod_1.z.object({
    reason: zod_1.z.string().min(1).max(500),
});
exports.rescheduleSchema = zod_1.z
    .object({
    newDate: localDate_js_1.localDateSchema,
    newStartMin: localDate_js_1.timeMinSchema,
    newEndMin: localDate_js_1.timeMinSchema,
    newResourceId: zod_1.z.string().uuid().optional(),
    reason: zod_1.z.string().max(500).optional(),
})
    // newStartMin < newEndMin: bounds-only validation on each field allows a
    // zero-length or negative-duration slot through to checkInstance(), which
    // would then write a malformed AppointmentInstance. Block at the schema.
    .refine((v) => v.newStartMin < v.newEndMin, {
    message: 'newStartMin must be earlier than newEndMin',
    path: ['newEndMin'],
});
exports.bulkCheckInSchema = zod_1.z.object({
    ids: zod_1.z.array(zod_1.z.string().uuid()).min(1).max(200),
});
//# sourceMappingURL=instance.js.map